import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { BMapLoader } from '@/utils/bdMap.js';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, formatToLine, formfileHandle, getdefaultVal, getFileStatus } from "@/utils/utils";
import { provinceAndCityData, pcTextArr, regionData, pcaTextArr, codeToText } from "element-china-area-data";
export default {
  name: 'mappointdata',
  props: ['mtObj', 'isAddDataflag', 'typeArr', 'leveloptions', 'detail', 'mapconfigData'],
  meta: {
    title: '坐标点添加/编辑'
  },
  components: {},
  data() {
    return {
      structList: [],
      // 表单结构集合
      sList: [],
      // 表单结构格式化集合
      form: {},
      // 表单form
      formlabel: {},
      // 表单字段名称
      formoption: {},
      dfileList: {},
      // 默认上传文件集合
      fileList: {},
      // 默认上传文件集合
      cfname: '',
      // 当前上传文件字段名称
      bdmap: {},
      // 选择地址回填对象
      bdDialog: false,
      // 百度地图弹框
      bdinput: '',
      BDMap: null,
      // 百度地图对象
      point: '',
      // 当前选择点
      options: regionData,
      selectedOptions: ['110000', '110100', '110101']
    };
  },
  mounted() {},
  watch: {},
  methods: {
    addressChange(arr) {
      // console.log(this.selectedOptions)
      // console.log(arr)
      // console.log(codeToText[arr[0]], codeToText[arr[1]], codeToText[arr[2]])
      this.form.pca = arr.join(',') + '|' + codeToText[arr[0]] + ',' + codeToText[arr[1]] + ',' + codeToText[arr[2]];
      // console.log(this.form.pca)
    },
    // 初始化操作
    init() {
      this.$nextTick(() => {
        // 减少请求次数优化
        console.log(`pointdataisAddDataflag: ${this.isAddDataflag}`);
        this.isAddDataflag ? this.getdefaultdata() : this.getdataDetail(this.detail);
      });
    },
    // 地点管理表单结构
    getDatastruct() {
      // if (this.structList.length > 0) return
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.sList = this.getformatstruct(res);
        console.log(this.sList);
        this.form.offsetX = this.mtObj.offsetX;
        this.form.offsetY = this.mtObj.offsetY;
        this.form.map_level = '';
        console.log(this.form);
      });
    },
    getformatstruct(data) {
      return data.map(i => {
        this.form[i.alias] = '';
        // 表单字段名称
        this.formlabel[i.alias] = i.label;
        // 表单字段默认值处理
        if (i.field.options) {
          this.formoption[i.alias] = i.field.options;
        }
        if (i.field.defaultValueStr) {
          let idStr = i.field.defaultValueStr;
          if (idStr) {
            let dStr = idStr === '[]' ? '' : JSON.parse(idStr);
            this.form[i.alias] = dStr !== '' ? dStr[0].val : '';
          }
        }
        let itemObj = {
          alias: i.alias,
          compt: i.compt,
          values: getFileStatus(i) ? [] : [{
            val: ''
          }]
        };
        return itemObj;
      });
    },
    // 上传文件点击事件 确定传哪个文件字段
    uploadClick(val) {
      this.cfname = val;
      console.log(`cfname: ${this.cfname}`);
    },
    // 上传文件
    uploadChange(rawFile) {
      console.log(rawFile);
      let formData = new FormData();
      formData.append('file', rawFile.raw);
      formData.append('_uid', this.$route.query.uid);
      formData.append('fid', this.$route.query.fid);
      this.$api.uploadSingle(formData).then(res => {
        res.url = handleHttp(res.http);
        let fdata = this.fileList[this.cfname];
        fdata && fdata.length > 0 ? this.fileList[this.cfname].push(res) : this.fileList[this.cfname] = [res];
        console.log(this.fileList[this.cfname]);
        this.dfileList[this.cfname] = JSON.parse(JSON.stringify(this.fileList[this.cfname]));
      });
    },
    // 删除图片文件操作
    handleRemove(file, name) {
      console.log(file);
      this.fileList[name] = this.fileList[name].filter(elem => {
        return elem.name !== file.name;
      });
      this.dfileList[name] = JSON.parse(JSON.stringify(this.fileList[name]));
      console.log(this.fileList[name]);
      console.log(this.dfileList[name]);
    },
    handleExceed(val) {
      console.log(this.cfname);
      console.log(val);
      this.uploadChange({
        raw: val[0]
      });
    },
    // 删除音视频文件操作
    removeHandle(val) {
      console.log(val);
      let name = this.cfname;
      console.log(`name: ${this.cfname}`);
      this.fileList[name] = this.fileList[name].filter(elem => {
        return elem.name !== val.name;
      });
      this.dfileList[name] = JSON.parse(JSON.stringify(this.fileList[name]));
    },
    // 获取静态地图上的定位点
    getCoordinate() {
      console.log(localStorage.getItem('coordinate'));
      this.form.map_coordinates = localStorage.getItem('coordinate');
    },
    // 返回按钮操作
    gobacktype() {
      // this.$refs.form.resetFields()
      this.$emit('goback');
    },
    // 添加情况 执行默认参数
    getdefaultdata() {
      // this.$ref.form.resetFields()
      let res = JSON.parse(JSON.stringify(this.structList));
      this.sList = this.getformatstruct(res);
      this.form.offsetX = this.mtObj.offsetX;
      this.form.offsetY = this.mtObj.offsetY;
      this.form.map_level = '';
      this.bdmap = {};
      Object.keys(this.fileList).forEach(elem => {
        this.fileList[elem] = [];
      });
      this.dfileList = JSON.parse(JSON.stringify(this.fileList));
      this.BDMap = null;
      this.point = '';
      console.log(this.form);
    },
    // 获取地点详情
    getdataDetail(val) {
      // 先清空表单数据
      this.getdefaultdata();
      // 表单字段赋值
      let formdata = val.formIdValueData;
      let data = val.itemformdata;
      Object.keys(formdata).forEach(items => {
        if (getFileStatus(formdata[items])) {
          this.dfileList[items] = data[items].length > 0 ? this.getfileformatForm(data[items]) : [];
          this.fileList[items] = data[items];
        }
        this.form[items] = data[transformStr3(items)];
      });
      let to = data.titleoffset.split(',');
      this.form.offsetX = parseInt(to[0]);
      this.form.offsetY = parseInt(to[1]);
      if (this.form.introduce) {
        this.form.introduce = new String(this.form.introduce).replace(/<[^>]+>/g, '');
      }
      if (!!this.form.pca) {
        let pca = this.form.pca.split('|')[0];
        this.selectedOptions = pca.split(',');
      }
      if (data.route.length > 0) this.bdmap = data.route[0];
      console.log(this.form);
    },
    // 点击提交/更新按钮  提交数据
    submitdataHandle() {
      let that = this;
      let formData = {
        deptId: this.$route.query.fid,
        formId: 165054,
        uid: this.$route.query.uid
      };
      let dataList = JSON.parse(JSON.stringify(this.sList));
      this.$refs['form'].validate(valid => {
        if (valid) {
          // console.log(that.form)
          // console.log(this.formlabel)
          // console.log(this.fileList)
          // console.log(this.structList)
          // console.log(this.sList)
          // console.log(this.mapconfigData)
          if (this.fileList[4] === undefined || this.fileList[4].length === 0) {
            ElNotification({
              message: '请上传地点图片',
              type: 'warning'
            });
            return;
          }
          dataList = dataList.map(item => {
            let v = this.form[item.alias];
            // 先统一处理下form字段值
            if (v === '' || v.length === 0) v = '';
            if (v.length === 1 && v[0].val === '') v = '';
            item.values = v;
            if (item.alias === 'titleoffset') {
              let oX = this.form.offsetX;
              let oY = this.form.offsetY;
              item.values = oX + ',' + oY;
            }
            // 处理文件字段赋值
            if (item.compt === 'imagebox' || item.compt === 'videobox' || item.compt === 'fileupload') {
              let filedata = '';
              Object.keys(this.fileList).forEach(elem => {
                if (elem === item.alias) filedata = this.fileList[elem];
              });
              console.log(filedata);
              if (filedata === '') return item;
              item.values = formfileHandle(filedata, item.compt, this.$route.query.uid);
            }
            // [this.bdmap]<p element-id=\"init\">1111111</p>
            // 处理定位赋值
            if (item.compt === 'location') {
              item.values = this.bdmap.address ? [this.bdmap] : '';
            }
            // 处理简介赋值
            if (item.alias === 'introduce') {
              this.form.introduce = new String(this.form.introduce).replace(/<[^>]+>/g, '');
              item.values = '<p element-id=\"init\">' + encodeURIComponent(this.form.introduce) + '</p>';
            }
            // 处理分类选择 编号自动填写
            if (item.alias === '43' && this.form.map_type !== '') {
              let typeobj = this.typeArr.find(item => item.value === this.form.map_type);
              item.values = typeobj ? typeobj.id : '';
            }
            // 处理表单固定字段校验
            if (item.alias === '40') item.values = this.mapconfigData.title;
            if (item.alias === 'title') item.values = this.mapconfigData.onlyid;
            // 链接字段编码
            if (item.alias === '44' && v !== '') item.values = encodeURIComponent(v);
            return item;
          });
          // dataList = dataList.filter(item => { return item.values !== '' && item.values.length !== 0 })
          dataList = dataList.map(item => {
            if (item.compt !== 'imagebox' && item.compt !== 'videobox' && item.compt !== 'location' && item.compt !== 'fileupload' && item.compt !== 'selectmultibox') {
              item.values = [{
                val: item.values
              }];
            }
            return item;
          });
          console.log(dataList);
          let _this = this;
          if (this.isAddDataflag) {
            this.$api.addFormdata(formData, encodeURI(JSON.stringify(dataList))).then(res => {
              ElNotification({
                message: '添加成功',
                type: 'success'
              });
              // _this.$refs.form.resetFields()
              _this.getdefaultdata();
              _this.$emit('success');
            });
          } else {
            this.$api.editForm(this.$route.query.fid, this.detail.id, encodeURI(JSON.stringify(dataList)), this.detail.formId).then(res => {
              ElNotification({
                message: '更新成功',
                type: 'success'
              });
              // _this.$refs.form.resetFields()
              _this.getdefaultdata();
              _this.$emit('success');
            });
          }
        }
      });
    },
    // 删除点 操作按钮
    deletedataHandle() {
      let _this = this;
      console.log(this.detail);
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let deleteform = {
          formId: this.detail.formId,
          formUserId: this.detail.id
        };
        this.$api.deleteFormdata(deleteform).then(res => {
          ElNotification({
            message: '删除成功',
            type: 'success'
          });
          // _this.$refs.form.resetFields()
          _this.$emit('success');
        });
      }).catch(() => {});
    },
    // 点击选择地图操作
    bdDialogHandle() {
      this.bdDialog = true;
      this.getLocation();
    },
    // 获取百度地图当前地址
    getLocation() {
      this.$nextTick(() => {
        BMapLoader().then(BMap => {
          this.BDMap = new BMap.Map('bdmap', {
            enableMapClick: false
          });
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition(a => {
            this.bdmap.address = a.address.city + a.address.district + a.address.street + a.address.street_number;
            this.bdmap.lng = a.point.lng;
            this.bdmap.lat = a.point.lat;
            this.point = new BMap.Point(a.point.lng, a.point.lat);
            this.BDMap.centerAndZoom(this.point, 15);
            this.BDMap.clearOverlays();
            let marker = new BMap.Marker(this.point);
            this.BDMap.addOverlay(marker);
          });
          this.BDMap.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
          // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
          this.searchComplate(BMap);
          let that = this;
          this.BDMap.addEventListener('click', function (e) {
            new BMap.Geocoder().getLocation(e.latlng, function (rs) {
              that.bdmap.address = rs.address;
              let surroundingPois = rs.surroundingPois;
              if (surroundingPois.length > 0) {
                let province = rs.addressComponents.province;
                if (surroundingPois[0].address.indexOf(province) === 0) province = '';
                let headAddress = (rs.addressComponents.province === rs.addressComponents.city ? '' : rs.addressComponents.city) + rs.addressComponents.district;
                if (surroundingPois[0].address.indexOf(headAddress) === 0 || surroundingPois[0].address.indexOf(rs.addressComponents.province + headAddress) === 0) {
                  headAddress = '';
                }
                that.bdmap.address = province + headAddress + surroundingPois[0].address + surroundingPois[0].title;
              }
            });
            that.bdmap.lng = e.latlng.lng;
            that.bdmap.lat = e.latlng.lat;
            that.point = new BMap.Point(e.latlng.lng, e.latlng.lat);
            that.BDMap.panTo(that.point);
            that.BDMap.clearOverlays();
            let marker = new BMap.Marker(that.point);
            that.BDMap.addOverlay(marker);
            console.log(that.bdmap);
          });
        });
      });
    },
    searchComplate(BMap) {
      let _this = this;
      //建立一个自动完成的对象
      let ac = new BMap.Autocomplete({
        'input': 'suggestId',
        'location': this.BDMap
      });
      let myValue;
      ac.addEventListener('onconfirm', function (e) {
        //鼠标点击下拉列表后的事件
        let _value = e.item.value;
        myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
        _this.G('searchResultPanel').innerHTML = 'onconfirm<br />index = ' + e.item.index + '<br />myValue = ' + myValue;
        _this.setPlace(myValue, BMap);
      });
    },
    G(id) {
      return document.getElementById(id);
    },
    setPlace(myValue, BMap) {
      this.BDMap.clearOverlays(); //清除地图上所有覆盖物
      let _this = this;
      const myFun = () => {
        let pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
        _this.BDMap.centerAndZoom(pp, 18);
        _this.BDMap.addOverlay(new BMap.Marker(pp)); //添加标注
        _this.bdmap.address = local.getResults().province + local.getResults().keyword;
        _this.bdmap.lng = pp.lng;
        _this.bdmap.lat = pp.lat;
      };
      let local = new BMap.LocalSearch(this.BDMap, {
        //智能搜索
        onSearchComplete: myFun
      });
      local.search(myValue);
    },
    // 获取文件路径（无fileUrl, 依据objectId)
    getfileformatForm(data) {
      // console.log(data)
      return data.map(item => {
        item.url = item.fileUrl;
        if (!item.fileUrl) {
          this.$api.getUrlByObjectId(item.objectId).then(res => {
            item.url = handleHttp(res.http);
          });
        }
        return item;
      });
    }
  }
};